/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Val2_TitleInputs */

const en_dr_room_val2_title = /** @type {(inputs: Dr_Room_Val2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI challenges, it doesn't invent`)
};

const id_dr_room_val2_title = /** @type {(inputs: Dr_Room_Val2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI menantang, bukan mengarang`)
};

/**
* | output |
* | --- |
* | "AI challenges, it doesn't invent" |
*
* @param {Dr_Room_Val2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_val2_title = /** @type {((inputs?: Dr_Room_Val2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Val2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_val2_title(inputs)
	return en_dr_room_val2_title(inputs)
});